import { GetStaticProps, NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';

import AccessTokenRequired from '@/components/AccessTokenRequired';
import AuctionActivity from '@/containers/AuctionActivity';

const AuctionActivityPage: NextPage = () => {
  const { t } = useTranslation();

  return (
    <AccessTokenRequired>
      <Head>
        <title>{t('auctionActivity.activity')} | ANIFTY</title>
      </Head>
      <AuctionActivity />
    </AccessTokenRequired>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default AuctionActivityPage;
